const FlagFrench = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='23' height='16' fill='none' viewBox='0 0 23 16'>
    <path fill='#CCCAC9' d='M22.732 0H0v15.279h22.732V0z'></path>
    <path fill='#132275' d='M7.642.186H.189v14.906h7.453V.186z'></path>
    <path fill='#fff' d='M15.095.186H7.642v14.906h7.453V.186z'></path>
    <path fill='#D70014' d='M22.547.186h-7.453v14.906h7.453V.186z'></path>
  </svg>
)

export { FlagFrench }
